import { useFetch } from 'services/useFetch'
import { API_SALE_PAGE } from 'services/apiSalePage'
import { useState } from 'react'
import { constructOptionMultipleSelect } from 'utils/utils'
import { ProductHighlight } from 'components/main-page/sale-page/product-highlight/ProductHighlight'

export const ProductHighlightContainer = ({ salePageDetail, onChangeForm, errorForm }) => {
    const { fetching: getProductList } = useFetch(API_SALE_PAGE.PRODUCT_LIST)
    const [optionsProduct, setOptionsProduct] = useState([])

    const onSearchProduct = (keyword) => {
        getProductList({ search: keyword }).then((response) => {
            const newList = constructOptionMultipleSelect(response?.data, 'name', 'id')
            setOptionsProduct(newList)
        })
    }

    const props = {
        salePageDetail,
        onSearchProduct,
        optionsProduct,
        onChangeForm,
        errorForm,
    }

    return <ProductHighlight {...props} />
}
